import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import InvoiceReceipt from './InvoiceReceipt';
import { FaSpinner, FaExclamationTriangle } from 'react-icons/fa';

function Receipt() {
  const { reference } = useParams();
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);

  // Mock data for testing
  const mockData = {
    id: "INV-CBTHOST123456",
    created_at: "2023-10-15 14:30:00",
    expires_at: "2024-10-15",
    plan: "yearly",
    amount: 150000.00,
    currency: "NGN",
    payment_method: "bank",
    status: "pending",
    bank_details: {
      bank_name: "Zenith Bank",
      account_name: "CBT Host Ltd",
      account_number: "1234567890",
      reference: "INV-CBTHOST123456"
    },
    payment_reference: null,
    email: "customer@example.com",
    items: [
      {
        name: "CBT Host Premium",
        description: "Premium hosting package with 24/7 support",
        plan: "yearly",
        amount: 150000.00
      }
    ],
    subtotal: 150000.00,
    total: 150000.00
  };

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      if (reference === mockData.id) {
        setInvoice(mockData);
      } else {
        setInvoice(null);
      }
      setLoading(false);
    }, 1000); // simulate network delay
  }, [reference]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen text-blue-600">
        <FaSpinner className="animate-spin text-4xl" />
      </div>
    );
  }

  if (!invoice) {
    return (
      <div className="flex flex-col items-center justify-center h-screen text-center px-4">
        <FaExclamationTriangle className="text-red-500 text-5xl mb-4" />
        <h2 className="text-2xl font-bold text-gray-800 mb-2">No Receipt Found</h2>
        <p className="text-gray-600 mb-4">
          Please check your reference. If you believe this is an error,
          contact our customer care at
        </p>
        <a href="mailto:support@cbthost.com" className="text-blue-600 font-medium">
          support@cbthost.com
        </a>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <header className="mb-8 text-center">
          <h1 className="text-3xl font-bold text-gray-800">CBT Host Invoice</h1>
          <p className="text-gray-600 mt-2">Professional hosting solutions</p>
        </header>
        
        <InvoiceReceipt invoice={invoice} />
      </div>
    </div>
  );
}

export default Receipt;
